import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DeleteMemberAccountComponent } from './delete-member-account/delete-member-account.component';

const routes: Routes = [
   { path: '', component: DeleteMemberAccountComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DeleteMemberAccountRoutingModule { }
